module.exports = __webpack_public_path__ + "static/img/01de7d5e080b8a215cb23e5e3644ce761e.388bc57.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/newComing/01de7d5e080b8a215cb23e5e3644ce761e.jpg
// module id = eNFR
// module chunks = 0